import { useEffect, useState } from 'react';
import { getCustomer } from '../../../../platform/ui-next/src/utils/getCustomerConfig';

export const useCustomerConfig = () => {
  const [customer, setCustomer] = useState<CustomerConfig>();

  useEffect(() => {
    async function init() {
      const customerKey = new URLSearchParams(window.location.search).get('customerKey');

      if (!customerKey) return;

      try {
        const customer = await getCustomer(customerKey);

        setCustomer(customer);
      } catch (error) {
        console.error('Error loading customer', error);
        setCustomer(null);
      }
    }

    init();
  }, []);

  return { customer };
};
